// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__27EN5","options":"AnswerScale_options__3nkpi","selected":"AnswerScale_selected__qW1g5"};